import type { ComponentSchema } from '../../../../../schema-types'

/** Tint band, then up to 4 products side by side: price, savings, pack size, price per kg / L / pc with the best value marked, attributes. */
export const schema: ComponentSchema = {
  type: 'compare',
  label: 'Compare',
  description: 'Up to four saved products side by side with pack size, price per unit and the best value marked, or an empty state.',
  supportedPages: ['compare'],
  variants: [{ id: 'v1', label: 'Side by side' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Compare products' },
    { key: 'emptyTitle', label: 'Empty title', type: 'string' },
    { key: 'emptyText', label: 'Empty message', type: 'string' },
  ],
}
